

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.3.1): index.umd.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

import Alert     from './ui/alert'
import Button    from './ui/button'
import Carousel  from './ui/carousel'
import Collapse  from './ui/collapse'
import Dropdown  from './ui/dropdown'
import Modal     from './ui/modal'
import Popover   from './ui/popover'
import ScrollSpy from './ui/scrollspy'
import Tab       from './ui/tab'
import Toast     from './ui/toast'
import Tooltip   from './ui/tooltip'

export default {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip
}



var $ = jQuery.noConflict();

$(function() {

// IconSystem
// ===========================
var ajax = new XMLHttpRequest();
ajax.open("GET", "/images/icons.svg", true);
ajax.send();
ajax.onload = function(e) {
  var div = document.createElement("div");
  div.className="c-Site__icons c-IconSystem";
  div.innerHTML = ajax.responseText;
  document.body.insertBefore(div, document.body.childNodes[document.body.childNodes.length -1]);
}

// ===========================
// end: IconSystem


// HeaderSearch
// ===========================

$('#headerSearch button').on('click', function() {
    if ($(window).width() >= 900) {
        
        if ($('.b-Form__group--search input').val() === "") {

            $('.c-NavMeta__item--search a').collapse('toggle');
            $('#headerSearch').collapse('toggle');
            return false;
        }
    }
});

// ===========================
// end: HeaderSearch


// Select2
// ===========================
$('.js-select2-single.home').select2({
  //theme: "flat"
    dropdownParent: $('.select-wrapper')
});

$('.js-select2-single.find').select2({
    //theme: "flat"
    dropdownParent: $('.select-wrapper-find')
});
// ===========================
// end: Select2


//console.log('ui.js has loaded!');

});